/*
 * @description:
 * @Author: liwg
 * @Date: 2022-07-08 15:30:49
 * @LastEditors: liwg
 * @LastEditTime: 2022-07-10 10:00:09
 */
import { i18n } from '../locales/index'

export function useI18n() {
  const { t: rawT, ...methods } = i18n.global

  return {
    t: rawT,
    ...methods
  }
}
